/* import __COLOCATED_TEMPLATE__ from './date-filter.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { DateTime } from '@square/dashboard-protos/models/squareup/common/time';
import { action } from '@ember/object';
import moment from 'moment';
import { getBrowserTimeZone } from '@dashboard/junk-drawer/utils/time';
import { tracked } from '@glimmer/tracking';
export function convertDateToDateTime(date, isStartOfDay) {
  let momentConvertedDate = moment(date).endOf('day');
  if (isStartOfDay) {
    momentConvertedDate = moment(date).startOf('day');
  }
  return DateTime.create({
    instantUsec: momentConvertedDate.toDate().getTime() * 1000,
    tzName: [getBrowserTimeZone()]
  });
}
let DateFilter = (_class = class DateFilter extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "startDate", _descriptor, this);
    _initializerDefineProperty(this, "endDate", _descriptor2, this);
    _initializerDefineProperty(this, "dateMenuSelection", _descriptor3, this);
  }
  get selectedDateCategory() {
    const uncapitalized = this.args.selectedDateCategory.replace('-', ' ');
    return uncapitalized.charAt(0).toUpperCase() + uncapitalized.slice(1);
  }
  dateRangeChanged(event) {
    // Do not set startDate or endDate to empty DateTime objects
    this.startDate = event.detail.startDate ? convertDateToDateTime(event.detail.startDate, true) : undefined;
    this.endDate = event.detail.endDate ? convertDateToDateTime(event.detail.endDate, false) : undefined;
    if (this.startDate || this.endDate) {
      this.args.dateRangeChanged(this.startDate, this.endDate);
    }
  }
  dateMenuSelectionChanged(event) {
    this.dateMenuSelection = event.detail.menuSelection;
    this.args.dateMenuSelectionChanged(this.dateMenuSelection);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "startDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "endDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dateMenuSelection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'This year';
  }
}), _applyDecoratedDescriptor(_class.prototype, "dateRangeChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dateRangeChanged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dateMenuSelectionChanged", [action], Object.getOwnPropertyDescriptor(_class.prototype, "dateMenuSelectionChanged"), _class.prototype), _class);
export { DateFilter as default };